import { AnyAction } from 'redux';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { VwgActions } from '../vwgActions';
import { IAppState } from '../appState';

export type PlzRequiresUwStatus = boolean | null | 'error';

function targetsThisAngebot(appId: App, angebotsId: string, appState: IAppState): boolean {
  return appId === App.VWG_V2 && angebotsId === appState.angebotsId;
}

export function plzRequiresUwReducer(
  sectionState: PlzRequiresUwStatus = null,
  action: AnyAction,
  appState: IAppState,
): PlzRequiresUwStatus {
  switch (action.type) {
    case VwgActions.PLZ_REQUIRES_UW_RECEIVED:
      return Boolean(action.payload);
    case VwgActions.PLZ_REQUIRES_UW_CHECK_FAILED:
      return 'error';
    case VwgActions.PLZ_CHANGED:
    case VwgActions.RESET_ADRESSDATEN:
      return null;
    case GlobalActions.IMMOBILIE_UEBERNEHMEN:
      return targetsThisAngebot(action.payload.appId, action.payload.angebotsId, appState)
        ? null
        : sectionState;
    default:
      return sectionState;
  }
}
